export default __webpack_public_path__ + "static/media/minLcdChair.b2132505.png";